import { DataTable } from '../components/DataTable.tsx';
import { ErrorState, LoadingState, StatusChip } from '../components/FdPrimitives.tsx';
import { useFetch } from '../hooks/useFetch.ts';

type Rule = {
  id: string;
  scope: string;
  action: string;
  description: string;
  version: number;
};

export function RulesPage() {
  const state = useFetch<{ rules: Rule[] }>('/rules');

  if (state.status === 'loading') return <LoadingState label="Loading rules" />;
  if (state.status === 'error') return <ErrorState message={state.message} />;

  return (
    <div className="page-stack">
      <DataTable
        title="Rules"
        icon="rule"
        rows={state.data.rules}
        emptyTitle="No rules found"
        emptyMessage="Global rule pack entries will appear when the console route is wired."
        columns={[
          { key: 'id', header: 'ID', className: 'cid' },
          { key: 'scope', header: 'Scope' },
          { key: 'action', header: 'Action', render: (rule) => <StatusChip value={rule.action} /> },
          { key: 'description', header: 'Description' },
          { key: 'version', header: 'Version' },
        ]}
      />
    </div>
  );
}
